import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import accountStatementReportTemplate from './accountStatementReport.template.html';

export default angular
  .module('books.ui.accountStatementReport', [csmCommonWeb, booksService])
  .directive('accountStatement', accountStatementDirective).name;

/* @ngInject */
function accountStatementDirective(BooksSvc, BusyScreen, $timeout) {
  /* This directive is used for the account statement report in ASBWorks as well as
    /* the category statement report and category group history report in PTA and Booster
    /*
    /* accountNumberHide
    /* Optional. Passthrough from the accountSelector directive. 
    /* Hides the account number input field when true. 
    /*
    /* selectorLabel
    /* Label for the input field.
    /* 
    /* hideEncumbrances
    /* Optional. Hides the encumbrances div when true.
    /* 
    /* hideBudgetAmt
    /* Optional. Hides the include budget amounts div when true.
    /* 
    /* hideReportStyle
    /* Optional. Hides the reporting style div when true. 
    /* 
    /* acctSin
    /* Label for type of report in singular format
    /*
    /* acctPL 
    /* Label for type of report in plural format
    /* 
    /* hideAccounts 
    /* Optional. Hides the "report by" div when true.
    /* 
    /* action
    /* The .aspx document to be opened on submit.
    /* 
    /* groupLabel
    /* Label for the Groups input 
    /* 
    /* csmRequired
    /* Boolean for date validation. If true the date fields must be populated. 
    */
  return {
    template: accountStatementReportTemplate,
    scope: {
      accountNumberHide: '=',
      selectorLabel: '@',
      hideEncumbrances: '&',
      hideBudgetAmt: '&',
      hideReportStyle: '&',
      acctSin: '@',
      acctPl: '@',
      hideAccounts: '&',
      action: '@',
      groupLabel: '@',
      csmRequired: '='
    },
    link: function ($scope, element, attr) {
      /*---------------------------*/
      /* Initialize Request Object */
      /*---------------------------*/
      $scope.req = { reportFormat: 'PDF', reportStyle: false };
      $scope.req.showEncum = $scope.hideEncumbrances() ? false : true;
      $scope.req.addBudget = $scope.hideBudgetAmt() ? false : true;

      /** Generic Data Storage Object. */ $scope.data = {};

      /** Report By Group Value. */ var mReportByGroup = false;

      /*****************************************************************************
       * data.reportByGroup */
      /**
       * Sets the req values when the group radio button is selected in the report.
       *****************************************************************************/
      $scope.data.reportByGroup = function (value) {
        if (!arguments.length) return mReportByGroup;

        mReportByGroup = value;

        $scope.req.accountID = 0;
        $scope.req.groupID = 0;
        $scope.req.order = 'true';
        $scope.req.sortBy = !mReportByGroup;
      };

      /*------------------------------------------------*/
      /* Initialize reportByGroup based on hideAccounts */
      /*------------------------------------------------*/
      $scope.data.reportByGroup($scope.hideAccounts() ? true : false);

      /*****************************************************************************
       * checkGroup */
      /**
       * Verifies that there is a valid ID in the group field. Sets it to zero if
       * invalid and clears the input field.
       *****************************************************************************/
      $scope.checkGroup = function () {
        if (!angular.isNumber($scope.req.groupID)) $scope.req.groupID = 0;
      };

      /*------------------------*/
      /* Date format validation */
      /*------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /*****************************************************************************
       * focus */
      /**
       *  Sets the focus on the group if hideAccounts is set to true and the
       *  account-selector is false.
       *****************************************************************************/
      element[0].focus = function () {
        $timeout(function () {
          element[0]
            .querySelector(
              $scope.hideAccounts() ? '#focusGroup' : 'account-selector'
            )
            .focus();
        });
      };

      /*****************************************************************************
       * formatLabel */
      /**
       * Returns the corresponding groups from the organization to display in the
       * groups typeahead.
       * When no match is found will return an empty string.
       *
       * @param  model  Current model value
       * @return        Corresponding group from the organization.
       *****************************************************************************/
      $scope.formatLabel = function (model) {
        if ($scope.groups)
          for (var i = 0; i < $scope.groups.length; i++) {
            if ($scope.groups[i].id == model) {
              return $scope.groups[i].description;
            }
          }
        return '';
      };

      /*--------------*/
      /* Get services */
      /*--------------*/
      BooksSvc.getAccountGroups().then(function (resp) {
        $scope.groups = resp.data;

        BooksSvc.getOrganization().then(function (resp) {
          $scope.org = resp.data;

          BooksSvc.getPermittedAccounts().then(function (resp) {
            $scope.accounts = resp.data;
          });
        });
      });
    }
  };
}
